import {
    Box,
    Button,
    Flex,
    IconButton,
    Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import Select from "react-select";
import { getManualExamMarksRequest } from "../../../modules/admin-modules/reports/Actions";
import { getManualExamsRequest } from "../../../modules/admin-modules/exams/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";

const ManualExamMarksReport = ({ setAdd, setSelectedData }) => {
    const dispatch = useDispatch();
    const [examId, setExamId] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const user = useSelector((state) => state.user.userData);

    // Get manual exam marks from Redux store
    const manualExamMarks = useSelector((state) => state.reports.manualExamMarks);

    useEffect(() => {
        dispatch(getManualExamsRequest());
    }, []);

    const getMarks = (id) => {
        setExamId(id);
        dispatch(getManualExamMarksRequest({ exam_id: id }));
    };

    const exams = useSelector((state) => state.exams.manualExams);

    const [offset, setPage] = useState(0);
    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [selected, setSelected] = useState({
        id: "",
    });

    const colourStyles = {
        control: (styles) => ({
            ...styles,
            width: "100%",
            background: "#f5f5f5",
            color: "#690000",
            borderRadius: "16px",
        }),
        option: (styles) => ({ ...styles, color: "#690000" }),
        menu: (styles) => ({ ...styles, zIndex: 9999 }),
        menuList: (styles) => ({ ...styles, zIndex: 9999 }),
    };

    const viewData = (data) => {
        setSelectedData(data);
        setSelected(data);
    };

    const headers = [
        { label: "name", key: "name" },
        { label: "phone", key: "phone" },
        { label: "score", key: "score" },
    ];

    const Data = manualExamMarks?.map((data, index) => {
        return {
            ...data,
            id: data?.student_id,
            name: data?.student?.name,
            phone: data?.student?.phone,
            score: data?.score || "لم يتم التقييم",
            parent_phone: data?.student?.parent_phone,
            user_name: data?.student?.user_name,
        };
    });

    // Filter data based on search term
    const filteredData = Data?.filter((item) => {
        if (!searchTerm) return true;
        const searchLower = searchTerm.toLowerCase();
        return (
            item.name?.toLowerCase().includes(searchLower) ||
            item.phone?.toLowerCase().includes(searchLower)
        );
    });

    const columns = [
        {
            Header: "اسم الطالب",
            accessor: "name",
        },
        {
            Header: "كود الطالب",
            accessor: "user_name",
        },
        {
            Header: "رقم الموبايل",
            accessor: "phone",
        },
        {
            Header: "رقم ولي الأمر",
            accessor: "parent_phone",
        },
        {
            Header: "الدرجة",
            accessor: "score",
        },
    ];

    return (
        <Layout>
            <div style={{ minHeight: "400px", marginTop: "100px" }}>
                <Text fontSize="24px" fontWeight="600" color="main_1">
                    تقرير درجات  امتحانات السنتر
                </Text>
                <VStack spacing={4} w="100%" my="30px">
                    <Flex w="100%" justifyContent="space-between" alignItems="center" style={{ position: 'relative', zIndex: 1000 }}>
                        <Select
                            options={exams.map((data) => {
                                return { value: data?.id, label: data?.name };
                            })}
                            isMulti={false}
                            onChange={(data) => {
                                getMarks(data?.value);
                            }}
                            styles={colourStyles}
                            placeholder="اختر الامتحان"
                        />
                    </Flex>
                    
                    <Flex w="100%" justifyContent="flex-start" alignItems="center">
                        <Input
                            placeholder="البحث بالاسم أو الكود..."
                            size="md"
                            w="300px"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Flex>
                </VStack>

                {filteredData?.length > 0 && (
                    <Flex w="100%" justifyContent="flex-end" mb="20px">
                        <CSVLink
                            data={filteredData}
                            headers={headers}
                            filename={`manual-exam-marks-${examId}-${dayjs().format("YYYY-MM-DD")}.csv`}
                        >
                            <Button colorScheme="blue" size="sm">
                                تصدير إلى Excel
                            </Button>
                        </CSVLink>
                    </Flex>
                )}

                <CTable
                    selectedData={viewData}
                    Columns={columns}
                    Data={filteredData}
                    path={"openModel"}
                    Actions
                    Title={``}
                    subTitle=""
                    btnTitle=""
                    placeHolder=""
                    noSearchBar={true}
                    noFilter={true}
                    footerBtnTitle
                    filterList
                    addButton
                    addButtonTitle=""
                    setPage={setPage}
                    setPerPage={setPerPage}
                    currentpage={pageNumber}
                    setPageNumber={setPageNumber}
                    noSecondSearchBar={true}
                    isLoading={false}
                    perPage={size}
                    totalPage={Math.ceil(10 / 50)}
                />
            </div>
        </Layout>
    );
};

export default ManualExamMarksReport;
